import React, { memo } from 'react';
import { useTranslations } from 'next-intl';

import { formatThousands } from '@wwe-portal/utils/format';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';

interface WrestlerDetailsTotalProps {
  talent: number;
  hp: number;
}

const WrestlerDetailsTotal: React.FC<WrestlerDetailsTotalProps> = ({
  talent,
  hp,
}) => {
  const t = useTranslations();

  return (
    <div className="3xl:gap-2.5 3xl:flex-col mt-[30px] flex w-full justify-between gap-5 md:mt-0">
      <div className="bg-back400 flex basis-1/2 items-center gap-2 rounded-md px-5 py-2.5">
        <IcoMoonIcon
          iconName="shield-cross-fill"
          className="text-blue700 h-[22px] w-[22px]"
        />
        <div>
          <div className="font-semibold">{formatThousands(talent)}</div>
          <span className="text-text500 text-xs">{t('total_talent')}</span>
        </div>
      </div>

      <div className="bg-back400 flex basis-1/2 items-center gap-2 rounded-md px-5 py-2.5">
        <IcoMoonIcon
          iconName="shield-cross-empty"
          className="text-blue700 h-[22px] w-[22px]"
        />
        <div>
          <div className="font-semibold">{formatThousands(hp)}</div>
          <span className="text-text500 text-xs">{t('total_hp')}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(WrestlerDetailsTotal);
